import { ROUTES } from '../constants';

const menu = [
	{
		key: 'home',
		title: 'Home',
		url: ROUTES.HOME,
	},
	{
		key: 'about',
		title: 'About',
		url: ROUTES.ABOUT,
	},
	{
		key: 'works',
		title: 'Works',
		url: ROUTES.WORKS,
	},
	{
		key: 'contact',
		title: 'Contact',
		url: ROUTES.CONTACT,
	},
];

export default menu;
